module.exports = __webpack_public_path__ + "static/eastwest-f1a6b2b1bb9cccf9ab1c2437fb30c229.png";